import { render } from "./InstrumentDetailPage.vue?vue&type=template&id=4da05b54&scoped=true"
import script from "./InstrumentDetailPage.vue?vue&type=script&lang=js"
export * from "./InstrumentDetailPage.vue?vue&type=script&lang=js"

import "./InstrumentDetailPage.vue?vue&type=style&index=0&id=4da05b54&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da05b54"]])

export default __exports__